module.exports = "https://www.gc-pro.gnp.com.mx/02209a952639af2f7bc13a2e9aa18b43.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/edit_gray_24px.png
// module id = 8100
// module chunks = 0